<template>
  <div id="main-content" class="day-off-calendar">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true">
          <el-form-item :label="$t('common.year')">
            <el-date-picker
                v-model="year"
                type="year"
                :placeholder="$t('common.pick_a_year')">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-row>
      <div class="day-off-calendar__months" v-if="isLoaded">
        <CalendarMonth
            v-for="(label, month) in MONTH_LIST"
            :key="`${yearString}_${month}`"
            :month="month"
            :offDateList="offDateList"
            :currentDate="currentDate"
            :year="yearString"></CalendarMonth>
      </div>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import CalendarMonth from '@/components/DayOff/CalendarMonth'
  import { MONTH_LIST } from "@/config"

  export default {
    name: "DayOffCalendar",
    components: {
      PageTitle,
      CalendarMonth
    },
    data: function () {
      return {
        title: 'day_off.day_off_calendar',
        backLink: `/general/day-off?action=back`,
        offDateList: [],
        isLoaded: false,
        MONTH_LIST,
        year: null,
        currentDate: null
      }
    },
    created: function () {
      this.year = this.$moment()
      this.currentDate = this.$moment().format('YYYY-MM-DD')
    },
    mounted: function () {
      let successCallback = (response) => {
        response.data.data.date_list.forEach((dateItem) => {
          this.offDateList.push(dateItem.date)
        })

        this.isLoaded = true
      }
      let payload = {
        successCallback
      }
      this.$store.dispatch('dayOff/retrieveDayOffDateList', payload)
    },
    computed: {
      yearString: function () {
        return this.$moment(this.year).format('YYYY')
      }
    },
    methods: {
      isDayOff (date) {
        return this.dateList.indexOf(date) !== -1
      }
    }
  }
</script>

<style lang="scss">
  .day-off-calendar {
    .el-calendar-day {
      padding: 0!important;

      p {
        padding: 8px;
        height: 100%;
        box-sizing: border-box;
        margin: 0;

        &.is-day-off {
          background: #ff0000;
          color: #fff;
        }
      }
    }
  }
</style>